import { route, tideForecastDetails } from '../../../features/TideTable/config/tideTable.config';

export { route };

export const details = tideForecastDetails;

export const layoutConfig = {
  '1x1': {
    visibleCount: ({ compactVisibleCount }) => compactVisibleCount,
    compactTimeUpdate: true,
    controlsClassName: 'd-flex',
    selectorMode: 'row',
    gridColumnCount: 1,
    selectorHeight: 'clamp(4.25rem, 32%, 4.75rem)',
    selectorGap: 6,
    selectorTileStyle: { padding: '0.25rem 0.35rem' },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column p-1',
    detailsClassName: 'pt-1 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(10, (layoutSize?.baseFontSize ?? 12) - 2),
    }),
    detailsIconSize: 13,
    detailGroups: [
      ['setOneHigh', 'setOneLow'],
      ['setTwoHigh', 'setTwoLow'],
    ],
  },

  '1x2': {
    visibleCount: () => 4,
    compactTimeUpdate: false,
    controlsClassName: 'd-flex',
    selectorMode: 'grid',
    gridColumnCount: 2,
    selectorHeight: 'clamp(8rem, 36%, 10rem)',
    selectorGap: 6,
    selectorListStyle: {
      gridTemplateRows: 'repeat(2, minmax(0, 1fr))',
    },
    selectorTileStyle: { padding: '0.45rem' },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column p-2',
    detailsClassName: 'pt-2 px-1',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, (layoutSize?.baseFontSize ?? 12) - 1),
    }),
    detailsIconSize: 15,
    detailGroups: [['setOneHigh', 'setOneLow', 'setTwoHigh', 'setTwoLow']],
  },

  '2x1': {
    visibleCount: () => 4,
    compactTimeUpdate: false,
    controlsClassName: 'd-flex',
    selectorMode: 'row',
    gridColumnCount: 1,
    selectorHeight: 'clamp(4.75rem, 38%, 6.25rem)',
    selectorGap: 8,
    selectorListStyle: { justifyContent: 'center' },
    selectorTileStyle: {
      flex: '0 0 calc((100% - 24px) / 4)',
      padding: '0.45rem',
    },
    wrapperClassName: 'd-flex h-100 w-100 flex-column overflow-hidden',
    contentClassName: 'd-flex w-100 flex-grow-1 min-h-0 flex-column px-2 pb-2',
    detailsClassName: 'pt-2 px-2',
    detailsStyle: ({ layoutSize }) => ({
      fontSize: Math.max(11, layoutSize?.baseFontSize ?? 12),
    }),
    detailsIconSize: 16,
    detailGroups: [
      ['setOneHigh', 'setOneLow'],
      ['setTwoHigh', 'setTwoLow'],
    ],
  },
};
